/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DailySummaryDto,
  GetDailySummaryParams,
  GetRangeSummaryParams,
  RangeSummaryDto
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDailySummaryUrl = (params?: GetDailySummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/summary/daily?${stringifiedParams}` : `/api/summary/daily`
}

/**
 * @summary Consumed vs budget for one day
 */
export const getDailySummary = async (params?: GetDailySummaryParams, options?: Parameters<typeof apiFetch>[1]): Promise<DailySummaryDto> => {

  return apiFetch<DailySummaryDto>(getGetDailySummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDailySummaryQueryKey = (params?: GetDailySummaryParams,) => {
    return [
    `/api/summary/daily`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDailySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDailySummary>>, TError = unknown>(params?: GetDailySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailySummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailySummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailySummary>>> = ({ signal }) => getDailySummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailySummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDailySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDailySummary>>>
export type GetDailySummaryQueryError = unknown


export function useGetDailySummary<TData = Awaited<ReturnType<typeof getDailySummary>>, TError = unknown>(
 params: undefined |  GetDailySummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailySummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailySummary>>,
          TError,
          Awaited<ReturnType<typeof getDailySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDailySummary<TData = Awaited<ReturnType<typeof getDailySummary>>, TError = unknown>(
 params?: GetDailySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailySummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailySummary>>,
          TError,
          Awaited<ReturnType<typeof getDailySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDailySummary<TData = Awaited<ReturnType<typeof getDailySummary>>, TError = unknown>(
 params?: GetDailySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailySummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consumed vs budget for one day
 */

export function useGetDailySummary<TData = Awaited<ReturnType<typeof getDailySummary>>, TError = unknown>(
 params?: GetDailySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailySummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDailySummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRangeSummaryUrl = (params: GetRangeSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/summary/range?${stringifiedParams}` : `/api/summary/range`
}

/**
 * Series for the trends charts, plus adherence. Max 366 days.
 * @summary Daily totals across a range
 */
export const getRangeSummary = async (params: GetRangeSummaryParams, options?: Parameters<typeof apiFetch>[1]): Promise<RangeSummaryDto> => {

  return apiFetch<RangeSummaryDto>(getGetRangeSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRangeSummaryQueryKey = (params?: GetRangeSummaryParams,) => {
    return [
    `/api/summary/range`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRangeSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getRangeSummary>>, TError = unknown>(params: GetRangeSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRangeSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRangeSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRangeSummary>>> = ({ signal }) => getRangeSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRangeSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRangeSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getRangeSummary>>>
export type GetRangeSummaryQueryError = unknown


export function useGetRangeSummary<TData = Awaited<ReturnType<typeof getRangeSummary>>, TError = unknown>(
 params: GetRangeSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRangeSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRangeSummary>>,
          TError,
          Awaited<ReturnType<typeof getRangeSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRangeSummary<TData = Awaited<ReturnType<typeof getRangeSummary>>, TError = unknown>(
 params: GetRangeSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRangeSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRangeSummary>>,
          TError,
          Awaited<ReturnType<typeof getRangeSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRangeSummary<TData = Awaited<ReturnType<typeof getRangeSummary>>, TError = unknown>(
 params: GetRangeSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRangeSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Daily totals across a range
 */

export function useGetRangeSummary<TData = Awaited<ReturnType<typeof getRangeSummary>>, TError = unknown>(
 params: GetRangeSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRangeSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRangeSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






